// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  dialogContainer: {
    '& .MuiDialog-paper': {
      width: '490px',
      height: 'auto',
    },
  },
  dialogTitle: {
    position: 'relative',
  },
  dialogTitleText: {
    fontWeight: 600,
    fontSize: '18px',
  },
  dialogTitleCloseButton: {
    position: 'absolute',
    right: 10,
    top: 10,
  },
  dialogTitleCloseButtonIcon: {
    color: '#788898',
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: 'auto',
    overflow: 'hidden',
  },
  dialogContentProjectsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 2,
    width: '100%',
  },
  moveFailedText: {
    color: theme.palette.error.main,
    marginTop: theme.spacing(1),
  },
  dialogContentProjectsList: {
    overflowY: 'auto',
    height: '200px',
    width: '100%',
  },
  dialogProgressContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
  dialogContentProjectsListItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 2,
  },
  dialogContentProjectsListItemIcon: {
    color: '#788898',
    fontSize: '20px',
  },
  dialogContentProjectsListItemIconSelected: {
    color: '#007AFF',
    fontSize: '20px',
  },
  dialogContentProjectsListItemText: {
    fontSize: '14px',
    fontWeight: 400,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '250px',
  },
  dialogContentProjectsListItemButton: {
    color: '#788898',
    marginLeft: 'auto',
  },
  dialogContentProjectsListItemButtonSelected: {
    color: '#007AFF',
    marginLeft: 'auto',
  },
  dialogActions: {
    padding: '16px 24px',
  },
  dialogActionsButton: {
    padding: '10px 24px',
    minWidth: '140px',
  },
  dialogActionsButtonProgress: {
    color: '#FFFFFF',
  },
  dialogContentProjectsListProgress: {
    position: 'relative',
    margin: '0 auto',
  },
});

export default styles;
